import { Component, forwardRef, OnInit } from "@angular/core";
import { ModelService } from "../../../../Services/model.service";
import { StartAction } from "../../../../Model/Dto/StartAction";
import { UserActionBaseComponent } from "../userAction-base.component";
import { TranslateService } from "@ngx-translate/core";
import { CatalogService } from "app/Services/CatalogManagement/catalog.service";
import { MacroService } from "app/Services/CatalogManagement/macro.service";
import { JobService } from "app/Services/job.service";
import { LoginService } from "app/Services/login.service";
import { Macro } from "../../../../Model/ui/Macro";

@Component({
    selector: "userAction-splitFeatureValuesFromUnit",
    templateUrl: "userAction-splitFeatureValuesFromUnit.component.html",
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionSplitFeatureValuesFromUnitComponent) }
    ],
    standalone: false
})
export class UserActionSplitFeatureValuesFromUnitComponent extends UserActionBaseComponent {

  foundUnitsToBeSplit: string[] = [];
  selectedUnits: string[];
  unitsLoading: boolean = false;

  constructor(public loginService: LoginService, public macroService: MacroService, public jobService: JobService, public translate: TranslateService, public catalogService: CatalogService) {
    super(loginService, macroService);
  }

  loadUnits() {
    this.foundUnitsToBeSplit.length = 0;
    this.unitsLoading = true;
    this.catalogService.getUnitsThatCanBeSplitFromFeatureValues(
      this.catalogService.selectedCatalogId,
      this.loginService.currentUser.customerId)
      .subscribe((unit) => {
        this.foundUnitsToBeSplit.push(...unit);

        this.unitsLoading = false;
      });
  }

  addCustomUnit(unit) {
    if (!unit.text) {
      unit.customItem = null;
      return;
    }
    this.foundUnitsToBeSplit.push(unit.text);
    this.selectedUnits.push(unit.text);
  }

  public async canStartMacro() : Promise<boolean>{
    if (!this.selectedUnits || this.selectedUnits.length == 0)
      return false;

   return true;
  }

  createUserAction(): StartAction {
    let userAction = new StartAction();
    userAction.catalogId = this.catalogService.catalog.id;
    userAction.customerId = this.loginService.currentUser.customerId;
    userAction.actionId = `SplitFeatureValuesFromUnit(${this.createParameterStringAsJsonString()})`;
    return userAction;
  }

  getActionId(macro: Macro): string {
    return `SplitFeatureValuesFromUnit(${this.createParameterStringAsJsonString()})`;;
  }

  createParameterStringAsJsonString(): string {
    let parameterJsonString = JSON.stringify(this.selectedUnits);
    return parameterJsonString;
  }

  public parseParameter(parameter: string) {
    throw new Error("Method not implemented.");
  }
}
